<template>
  <form-field
    :label="isSidebarFilter ? '' : label"
    :validation-errors="validationErrors"
    :help-text="helpText"
    class="form-checkbox-group"
  >
    <template v-if="isSidebarFilter">
      <div class="flex flex-between checkbox_filter--box">
        <h5 class="checkbox_filter--label">{{ label }}</h5>

        <div class="checkbox_filter--select_all">
          <button-link
            @click="$emit('selectAll', $event)"
            class="checkbox_filter--select_all--button"
          >select all
          </button-link>
          <button-link
            @click="$emit('deselectAll', $event)"
            class="checkbox_filter--select_all--button"
          >deselect all
          </button-link>
        </div>
      </div>
    </template>
    <template v-else>
      <div class="flex mb-50">
        <button-link
          @click="$emit('selectAll', $event)"
          class="mr-100"
        >
          Select All
        </button-link>

        <button-link @click="$emit('deselectAll', $event)">
          Deselect All
        </button-link>
      </div>
    </template>

    <div
      v-for="item in items"
      :key="item.id"
    >
      <!-- https://buefy.org/documentation/checkbox  -->
      <b-checkbox
        :value="value"
        :native-value="item.id"
        @input="handleInput"
        size="is-small"
      >
        {{ item.label }}
      </b-checkbox>
    </div>
  </form-field>
</template>

<script>
import FormField from "./FormField";
import {FormFieldMixin} from "./FormField.mixin";

export default {
  name: "FormFieldCheckboxGroup",
  components: {FormField},
  mixins: [FormFieldMixin],
  props: {
    value: {},
    label: {
      type: String,
    },
    items: {
      type: Array,
      required: true
    },
    validationErrors: {
      type: [String, Array, undefined],
    },
    helpText: {
      type: String
    },
    isSidebarFilter: {
      type: Boolean,
      default: false,
    },
  },
  methods: {
    handleInput(val) {
      this.$emit('input', val);
      this.$emit('change', val);
      this.$emit('selected', val);
      this.emitGlobalFieldChangeEvent();
    },
  }
}
</script>

<style lang="scss" scoped>
@import "../../styles/variables/variables";

.form-checkbox-group::v-deep {
  .field.has-addons {
    display: block;
  }
}

::v-deep .b-checkbox.checkbox {
  margin-bottom: 4px;
}

.checkbox_filter {
  &--box {
    padding: 0 4px 8px 0;
  }

  &--label {
    font-size: 0.875rem;
    font-weight: normal;
  }

  &--select_all {
    display: flex;

    &--button {
      margin-left: 10px;
    }
  }
}
</style>
